import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pcl-criteria-icon',
  templateUrl: './pcl-criteria-icon.component.html'
})
export class PclCriteriaIconComponent implements OnInit {
  @Input() criteria:string;
  @Input() checked:boolean;
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/pcl-criteria-icon/pcl-criteria-icon.component.ts